module.exports = __webpack_public_path__ + "fonts/TTNormsPro-Bold.8da732d2.woff2";